import S3DocsFeature from '../../features/docs/s3-feature';

export default function S3DocsPage() {
  return <S3DocsFeature />;
}
